import { StickyContainer, Sticky } from 'react-sticky';

var CSSTransition = require("react-transition-group/CSSTransition");
var TransitionGroup = require("react-transition-group/TransitionGroup");

var CurrentUser = require("lib/account/CurrentUser");
var Skillsets = require("lib/academic/Skillsets");
var AltSkillsets = require("lib/academic/AltSkillsets");
var Spinner = require("components/utility/Spinner");
var Glyphicon = require("components/utility/icons/Glyphicon");
var PaywallModal = require("components/users/teachers/PaywallModal");

require("data/comparisons_table.scss");

class ComparisonsTable extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			expandedStudentListID: null
		};
	}

	showPaywall() {
		this.refs.paywallModal.show();
	}

	toggleExpandStudentRows(studentListID) {
		if (this.props.showPaywallModal) {
			this.showPaywall();
		} else {
			if (this.state.expandedStudentListID != studentListID) {
				this.setState({ expandedStudentListID: studentListID });
			} else {
				this.setState({ expandedStudentListID: null });
			}

			// ONLY doing this because the height is not know in advance, otherwise would use CSS 
			// Check out this post on why it's hard to do this with CSS transitions:
			// https://jdsteinbach.com/css/holy-grail-css-animation/
			setTimeout(function() {
				$(this.refs.wrap).find(".studentRows.expand-enter").stop().slideDown(ComparisonsTable.EXPAND_TIME);
				$(this.refs.wrap).find(".studentRows.expand-leave").stop().slideUp(ComparisonsTable.EXPAND_TIME);
			}.bind(this), 50)
		}
	}

	getStandardSkillsets() {
		if (this.props.skillsetStandard && this.props.skillsetStandard != "wrss") {
			return AltSkillsets.getSubStandards(this.props.skillsetStandard);
		} else {
			return Skillsets.READING_SKILLSET_KEYS;
		}
	}

	getSkillsetName(key) {
		if (this.props.skillsetStandard && this.props.skillsetStandard != "wrss") {
			return AltSkillsets.getName(key);
		} else {
			return Skillsets.TYPES[key].name;
		}
	}

	levelCellWidth() {
		var fullWidth = 67.2; // 4.8rem * 14, based on the original design with 14 skillsets
		var skillsetCount = this.getStandardSkillsets().length;
		return (fullWidth / skillsetCount) + "rem";
	}

	renderColumnHeaders(levelCellWidth) {
		var columnHeaderCells = _.map(this.getStandardSkillsets(), function(key) {
			return (
				<div className="headerTextWrap" style={{ width: levelCellWidth }}>
					<div key={ key } className="headerText">
						{ this.getSkillsetName(key) }
					</div>
				</div>
			);
		}.bind(this));

		return columnHeaderCells;
	}

	renderHeaderRows(stickyProps) {
		var levelCellWidth = this.levelCellWidth();

		var paddingCells = _.map(this.getStandardSkillsets(), function(key) {
			return (
				<div key={ key } className="levelCellWrapper" style={{ width: levelCellWidth }}>
					<div className="levelCell">
					</div>
				</div>
			);
		})
		var paddingRow = (
			<div className="paddingRow">
				<div className="nameCell">
				</div>
				{ paddingCells }
			</div>
		);
		var stickyStyle = _.extend({}, stickyProps.style, { top: "45px" });
		var headerRows = (
			<div className="headerRows" style={ stickyStyle }>
				<div className="columnHeaders">
					{ this.renderColumnHeaders(levelCellWidth) }
				</div>
				{ paddingRow }
			</div>
		);

		return headerRows;
	}

	renderLevelCells(performanceData, levelCellWidth) {
		var levelCells = _.map(this.getStandardSkillsets(), function(key) {
			var cellClassName = "levelCell"
			if (!performanceData[key]) {
				cellClassName += " missing";
			} else if (performanceData[key].level == "above") {
				cellClassName += " green";
			} else if (performanceData[key].level == "at") {
				cellClassName += " yellow";
			} else if (performanceData[key].level == "below") {
				cellClassName += " red";
			} else {
				cellClassName += " missing";
			}
			return (
				<div key={ key } className="levelCellWrapper" style={{ width: levelCellWidth }}>
					<div className={ cellClassName }>
					</div>
				</div>
			);
		});

		return levelCells;
	}

	render() {
		var tableDescription = (
			<div className="tableDescription">
				Your students compared to the national average for students in a similar demographic.
			</div>
		);

		if (_.isEmpty(this.props.comparisonData)) {
			return (
				<div className="comparisonsTable">
					{ tableDescription }
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		}

		var levelCellWidth = this.levelCellWidth();

		var tableRows = _.map(this.props.studentLists, function(studentList) {
			if (!_.has(this.props.comparisonData, studentList.id)) {
				return null;
			}

			var classComparisonData = this.props.comparisonData[studentList.id];
			var classComparisonCells = this.renderLevelCells(
				classComparisonData.group_results, levelCellWidth);


			// render the student rows only if this student list is currently expanded
			if ((studentList.id == this.state.expandedStudentListID) || this.props.expandAll) {
				var studentRows = _.map(studentList.students, function(student) {
					if (classComparisonData && (student.id in classComparisonData.user_results)) {
						var studentComparisonCells = this.renderLevelCells(
							classComparisonData.user_results[student.id], levelCellWidth);
					}
					return (
						<div className="studentRow" key={ student.id }>
							<div className="nameCellWrapper">
								<div className="nameCell ellipsisText">
									{ student.display_name }
								</div>
							</div>
							{ studentComparisonCells }
						</div>
					);
				}.bind(this));

				if (this.props.expandAll) {
					var studentRowsStyle = { display: "block" };
				}

				var studentRowSection = (
					<CSSTransition classNames="expand"
						timeout={{
							enter: ComparisonsTable.EXPAND_TIME + 100,
							exit: ComparisonsTable.EXPAND_TIME + 100 }} >

						<div className="studentRows" style={ studentRowsStyle }>
							{ studentRows }
						</div>
					</CSSTransition>
				)

				var dropdownIcon = "triangle-bottom";
			} else {
				var dropdownIcon = "triangle-right";
			}


			return (
				<div key={ studentList.id }>
					<div className="studentListRow clickableElement"
						onClick={ this.toggleExpandStudentRows.bind(this, studentList.id) }>
						<div className="nameCell ellipsisText">
							{ studentList.name } <Glyphicon icon={ dropdownIcon } className="arrow hideOnPrint" />
						</div>
						{ classComparisonCells }
					</div>
					<TransitionGroup>
						{ studentRowSection }
					</TransitionGroup>
				</div>
			);
		}.bind(this));

		// Check to see if any are still loading in
		var compactTableRows = _.compact(tableRows);
		if (compactTableRows.length != tableRows.length) {
			var stillLoading = (
				<Spinner placeholder={ true } scale={ 1.7 } />
			);
		}

		var tableLegend = (
			<div className="tableLegend">
				<div className="legendItem">
					<div className="green"></div>
					More than 10% above
				</div>
				<div className="legendItem">
					<div className="yellow"></div>
					Within 10%
				</div>
				<div className="legendItem">
					<div className="red"></div>
					More than 10% below
				</div>
				<div className="legendItem">
					<div className="missing"></div>
					Not enough data
				</div>
			</div>
		);

		if (this.props.showPaywallModal) {
			var paywallModal = ( 
				<PaywallModal ref="paywallModal" featureType={ PaywallModal.COMPARISONS } /> 
			);
		}

		return (
			<div className="comparisonsTable" ref="wrap">
				{ tableDescription }
				<StickyContainer>
					<Sticky topOffset={ -35 }>
						{ this.renderHeaderRows }
					</Sticky>
					{ compactTableRows }
					{ stillLoading }
				</StickyContainer>
				{ tableLegend }
				{ paywallModal }
			</div>
		);
	}
}

ComparisonsTable.EXPAND_TIME = 400;

ComparisonsTable.propTypes = StrictPropTypes({
	studentLists: PropTypes.array.isRequired,
	comparisonData: PropTypes.object.isRequired,
	skillsetStandard: PropTypes.string,
	expandAll: PropTypes.bool,
	showPaywallModal: PropTypes.bool,
});


module.exports = ComparisonsTable;



// WEBPACK FOOTER //
// ./modules/components/data/ComparisonsTable.js